import { redirect } from '@tanstack/react-router';
import type { IRouterWithAuthContext } from '../types/auth/authContext';

/**
 * Check if user is authenticated, redirect to login if not
 *
 * @param context
 * @returns boolean
 */
export const requireAuth = (context: IRouterWithAuthContext) => {
  const isAuthenticated = context.auth.isAuthenticated;

  if (!isAuthenticated) {
    throw redirect({
      to: '/',
    });
  }
};

/**
 * Check if user has required access (i.e. have the appropriate app_metadata --> groupIds), redirect to unauthorized if not
 *
 * @param context
 * @returns boolean
 */
export const requireAccess = (context: IRouterWithAuthContext) => {
  // First check if authenticated
  requireAuth(context);

  if (
    context.authMetadata.groupIds === undefined ||
    context.authMetadata.groupIds?.length === 0
  ) {
    throw redirect({
      to: '/unauthorized',
    });
  }
};
